#import "../fragments/chat-settings-fragment.graphql"

mutation UpdateChatSettings($input: ChatSettingsUpdateInput!) {
    chatSettingsUpdate(input: $input) {
        ...ChatSettingsFragment
    }
}
